export const RESPONSE_HOURS_DEFAULT = 48;
export const RESPONSE_HOURS_OPTIONS = [24, 48, 72, 168];

export function responseHoursLabel(h) {
  if (h % 24 === 0 && h >= 72) return `${h / 24} days`;
  return `${h} hours`;
}

// 5h 12m / 2d 3h / under 1m ; takes a non-negative number of seconds
export function formatTimeLeft(seconds) {
  const s = Math.max(0, Math.floor(seconds));
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m`;
  return "under 1m";
}

// Normalised view of an expiry for chips: { kind: 'expired' | 'soon' | 'ok', label } or null (legacy, no expiry)
export function expiryInfo(secondsLeft) {
  if (secondsLeft === null || secondsLeft === undefined) return null;
  if (secondsLeft <= 0) return { kind: "expired", label: "Expired" };
  return {
    kind: secondsLeft < 12 * 3600 ? "soon" : "ok",
    label: `Expires in ${formatTimeLeft(secondsLeft)}`,
  };
}

export const EXPIRY_CHIP_CLASS = {
  expired: "!bg-[#fdecea] !text-[#c62828] !border-[#c62828]",
  soon: "!bg-[#fff4e0] !text-[#b26a00] !border-[#b26a00]",
  ok: "!bg-[#f1f3f5] !text-[#555] !border-[#c8cdd2]",
};
